// your custom js
import { Carousel, LoadTransition, Slider, HomeCollectionSlider, ScrollLock } from './comp';
import barba from '@barba/core';
import { collcollection, FetchData } from './filters';
import gsap from 'gsap';
import Circles from './circles';
import Swiper from 'swiper/bundle';
import fullpage from 'fullpage.js';
import { stocksOffCanvas } from './stocks';

window.onbeforeunload = function(e) {
	window.scrollTo(0, 0);
};

var scrollobject;

export function tt__init() {
	menu_init();
	findtaxid();
	//download init
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		var fileurl = jQuery('.popup-content').data('fileurl');
		if ( fileurl != undefined ) {
			setCookie("descargas_tpl_cookie", "formfilled", 7);
			location = fileurl;
		}
	}, false );
	//download stop

	jQuery('.activate-fullpage').each( function() {
		if ( jQuery(window).width() > 1023 ) {
			new fullpage(this, {
				autoScrolling: true,
				licenseKey: '7C5EAC5E-F2B043F1-B39F2D82-23105C6D',
				slidesNavigation: true,
				slidesNavPosition: 'right',
				responsiveWidth: 760,
			});
		}
	} );

	//Video play on click
	jQuery(".playvideo").each( function() {
		jQuery(this).on('click', function (e) {
			e.preventDefault();
			if ( jQuery(this).hasClass("stop") ) {
				jQuery('.playvideo').addClass("stop");
				jQuery(this).removeClass("stop");
			} else {
				jQuery(this).addClass("stop");
			}
		});
	});

	jQuery(".video-corner .playbutton").each( function() {
		jQuery(this).on('click', function (e) {
			e.preventDefault();
			var video = document.getElementById('fullvideo');
			if ( jQuery(this).hasClass("paused") ) {
				jQuery(this).removeClass("paused");
				jQuery('.screenpusher').removeClass("hidecontent");
				video.pause();
			} else {
				jQuery(this).addClass("paused");
				jQuery('.screenpusher').addClass("hidecontent");
				video.play();
			}
		});
	});
	// Download showmore

	jQuery(".showmore").on('click', function (e) {
		e.preventDefault();
		var datatoshow = jQuery(this).data('boxid');
		var showless = jQuery(this).data('less');
		var showmore = jQuery(this).data('show');
		if(jQuery(this).hasClass('active')) {
			jQuery(datatoshow).slideUp();
			jQuery(this).removeClass('active');
			jQuery(this).html(showmore);
		} else {
			jQuery(datatoshow).slideDown();
			jQuery(this).addClass('active');
			jQuery(this).html(showless);
		}
	});

	//Circles
	rocersa_makecircle("circles1", true);
	rocersa_makecircle("circles2", false);

	Slider();
	HomeCollectionSlider();

	if (barba.data && !barba.data.next.container) {
		ToggleMuteVideos(document);
	}

	if (window.matchMedia("(max-width: 1025px)").matches) { // If media query matches
		// nothing will happen in mobile
	} else {
		jQuery("#scrollock").each( function() {
			scrollobject = new ScrollLock();
		});
	}

	document.querySelectorAll("[data-carousel]").forEach(
        (el) => new Carousel({ el })
    );

    const homeele = document.getElementById("c1");
    if (homeele) {
        const lt = new LoadTransition({ target: "c1" });

        setTimeout(() => {
            lt.animate(() => {
                gsap.fromTo(document.querySelectorAll("#c1 .o-line > *"), 
                    {
                        yPercent: 100
                    },
                    {
                        yPercent: 0,
                        duration: 0.64,
                        ease: "power2.out",
                        stagger: 0.16,
                        overwrite: true
                    }
                );
            });
        }, 1000);
    }

    const videoholder = document.getElementById('fullvideo');
    if (videoholder) { videoholder.play(); }


	sliderdds();
	//sliderLam();
	lamDisplay();
	//tabControl();
	slidersingle();

	jQuery(".home-ins-section").on('click', function (e) {
		e.preventDefault();

		if ( jQuery(this).hasClass("active") ) {
			jQuery(".home-ins-section").removeClass("active");
			jQuery(".ins-product-collection").removeClass("active");
			jQuery(".ins-product-collection").slideUp();

		} else {
			jQuery(".home-ins-section").removeClass("active");
			jQuery(".ins-product-collection").removeClass("active");
			jQuery(".ins-product-collection").slideUp();

			var holder = jQuery(this).data("holder");
			jQuery(this).addClass("active");
			jQuery("." + holder).addClass("active");
			jQuery("." + holder).slideDown();

		}

	});

	addori_class();


	/* Menu Functions */
	jQuery(".menutrigger").on('click', function (event) {
		event.preventDefault();

		if ( jQuery("body").hasClass("menuopen") ) {
			menuclose();

		} else {
			menuopen();

		}

	});

	jQuery('a[href^="#"].makescroll').on('click', function (event) {
		var target = jQuery(this.getAttribute("href"));
		var offset = jQuery(this).data("offset");

		if ( target.length ) {
			event.preventDefault();

			if ( offset ) {
				jQuery("html, body").stop().animate({
						scrollTop: target.offset().top - offset,
					}, 1000 );

			} else {
				jQuery("html, body").stop().animate({
					scrollTop: target.offset().top,
				}, 1000 );

			}
		}
	});

	//Click event to scroll to top
	jQuery(".scrolltotop").on('click', function (e) {
		e.preventDefault();

		jQuery("html, body").stop().animate({
			scrollTop: 0,
		}, 800 );

		return false;
	});

	jQuery(".videowrap").hover(
		function () {
			var video = jQuery(this).find("video")[0];
			if (video) video.play();
		},
		function () {
			var video = jQuery(this).find("video")[0];
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
		}
	);

	jQuery(".filteropen").on('click', function (e) {
		e.preventDefault();

		if ( jQuery(".coll-search-wrap").hasClass("active") ) {
			jQuery(".coll-search-wrap").removeClass("active");
			jQuery(".col-filters").slideUp();

		} else {
			jQuery(".coll-search-wrap").addClass("active");
			jQuery(".col-filters").slideDown();

		}
	});

	jQuery(".colorlist").on('click', function (e) {
		e.preventDefault();

		if ( !jQuery(this).hasClass("active") ) {
			jQuery(".colorlist").removeClass("active");
			jQuery(".tabbox").removeClass("active");
			var holder = jQuery(this).data("tab");
			jQuery(this).addClass("active");
			jQuery(".tab-" + holder).addClass("active");
		}
	});

	jQuery(".ct-link-trigger").on('click', function (e) {
		e.preventDefault();

		var ele = jQuery(this).data("box");
		if ( jQuery(this).hasClass("active") ) {
			jQuery(this).removeClass("active");
			jQuery(".extra-contact-wrap").slideUp();
			jQuery("." + ele).removeClass("active");

		} else {
			jQuery(".ec-box").removeClass("active");
			jQuery(".ct-link-trigger").removeClass("active");
			jQuery(this).addClass("active");
			jQuery("." + ele).addClass("active");
			jQuery(".extra-contact-wrap").slideDown();

		}

	});

	jQuery(".closebox").on('click', function (e) {
		jQuery(".ec-box").removeClass("active");
		jQuery(".ct-link-trigger").removeClass("active");
		jQuery(".extra-contact-wrap").slideUp();

	});

	//Color big image control
	 jQuery(".linkcircle").on('click', function (e) {
		e.preventDefault();
		var data = jQuery(this).data('cbimag');

		if ( jQuery(this).hasClass("active") ) {
			jQuery(this).removeClass("active");
			jQuery(data).slideUp();
		} else {
			jQuery('.colorbig-image').slideUp();
			jQuery('.linkcircle').removeClass("active");
			jQuery(this).addClass("active");
			jQuery(data).slideDown();
		}
	});
	jQuery(".colorbig-image").on('click', function (e) {
		jQuery('.colorbig-image').slideUp();
		jQuery('.linkcircle').removeClass("active");
	}); 


	jQuery(".tab-item").on('click', function (e) {
		e.preventDefault();

		if ( !jQuery(this).hasClass("active") ) {
			jQuery(".tab-item").removeClass("active");
			jQuery(".tab-box").removeClass("active");
			var holder = jQuery(this).data("tab");
			jQuery(this).addClass("active");
			jQuery("#" + holder).addClass("active");
		}
	});
// collection order and search setting

jQuery(".sortingbox").on('click', function (e) {
	e.preventDefault();
	if ( jQuery(this).hasClass("active") ) {
		jQuery(this).removeClass('active');
	} else {
		jQuery(this).addClass('active');
	}
});

jQuery(".sortme").on('click', function (e) {
	e.preventDefault();
	var ele=jQuery(this);
	var order = ele.data('order');
	var orderby = ele.data('orderby');
	var html = ele.html();
	jQuery('.currentsorting').html(html);
	jQuery('.products-all').data('order', order);
	jQuery('.products-all').data('orderby', orderby);
	FetchData()
});

var lastentry = "";
jQuery(".searchinput").keyup(function(event) {
	if(jQuery('.searchinput').val() != lastentry) {
		var search = jQuery(this).val();
		jQuery('.products-all').data('search', search);
		FetchData();
		if(jQuery('.searchinput').val() != '') {
			jQuery('.clearsearch').show();
		} else {
			jQuery('.clearsearch').hide();
		}
	}
	lastentry = jQuery(".searchinput").val()
 });
 jQuery(".clearsearch").on('click', function (e) {
	e.preventDefault();
	var ele=jQuery('.searchinput');
	ele.val('');
	var search = ele.val();
	jQuery('.products-all').data('search', search);
	FetchData();
	jQuery('.clearsearch').hide();
});

jQuery(".searchsubmit").on('click', function (e) {
	e.preventDefault();
	var ele=jQuery('.searchinput');
	var search = ele.val();
	jQuery('.products-all').data('search', search);
	FetchData()
});
// COllection ends


	//menu hover
	jQuery(".bottom-nav .menu-item").hover(
		function () {
			var openmenu_id = jQuery(this).data('openmenu');
			open_menu(openmenu_id);
		}
	);

	jQuery(".menucloaser").hover(
		function () {
			close_menu();
		}
	);

	jQuery(".menuclose-col").on('click', function (e) {
		e.preventDefault();
		close_menu();
	});
	//menu hover ends

	//newsletter

	jQuery(".newsletter-title").on('click', function (e) {
		e.preventDefault();
		if ( jQuery(this).hasClass("closed") ) {
			jQuery('.nw-wrap').slideUp();
			jQuery(this).removeClass("closed");
		} else {
			jQuery('.nw-wrap').slideDown();
			jQuery(this).addClass("closed");
		}
	});
	// nw ends

	jQuery(".openpopup").on( 'click', function (e) {
		e.preventDefault();
		var popup = jQuery(this).data('popup');
		var popupid= '#popup-'+ popup;

		//jQuery('.popup-content input[type="hidden"]').val('');

		if ( popup == 'download' ) {
			var down = jQuery(this).data('fileid');

			if ( descargas_tpl__cookie_status() ) {
				window.location = down;
				return false;

			} else {
				jQuery('.popup-content').data('fileurl', down );
				jQuery('#fileurl-field').val(down);
			}
		}

		var name = jQuery(this).data('title');
		var email = jQuery(this).data('email');
		if(name) {
			jQuery('#filetitle-field').val(name);
		}
		if(email) {
			jQuery(popupid +' .email-field').val(email);
		}

		if ( jQuery(popupid).hasClass("opened") ) {
			closePopup(popupid);
		} else {
			openPopup(popupid);
		}


	});

	jQuery(".closepopup").on('click', function (e) {
		jQuery('.popup-content').data('fileurl', '' );
		jQuery('.popup-wrap').removeClass('opened');
	});

	// Collection!!!
	jQuery('.allproducts-section .products-all').each( function() {
		collcollection();
		FetchData();
	} );



	jQuery(".clearfilter").on('click', function() {
		jQuery(".clicked").removeClass("clicked");
		FetchData();
	});

	jQuery('.collections').on('click', function(e) {
		e.preventDefault();

		if ( jQuery(this).hasClass("disabled") )
			return;

		jQuery(this).toggleClass("clicked");

		FetchData();

	});

	// Stocks off canvas
	stocksOffCanvas();
}


// *** Other Functions!!! ***
window.onresize = function (event) {
	addori_class();
};

function isPortrait() {
	return window.innerHeight > window.innerWidth;
}

function isLandscape() {
	return window.orientation === 90 || window.orientation === -90;
}

function addori_class() {
	if ( isPortrait() ) {
		jQuery("body").addClass("view-portrait");
		jQuery("body").removeClass("view-landscape");

	} else {
		jQuery("body").addClass("view-landscape");
		jQuery("body").removeClass("view-portrait");

	}
}



var ddsslider;
function sliderdds() {
	if(jQuery('#ddslider').length > 0) {
		ddsslider = new Swiper("#ddslider", {
			slidesPerView: 1,
			loop: true,
			effect: "fade",
			fadeEffect: { crossFade: true },
			autoplay: { delay: 8000, disableOnInteraction: false },
			speed: 700,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}
}
var psslider;
function sliderps(ele) {
	if(jQuery("#psslider-"+ele).length > 0) {
		psslider = new Swiper("#psslider-"+ ele, {
			slidesPerView: 1,
			loop: true,
			autoplay: { delay: 8000, disableOnInteraction: false },
			speed: 700,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}
}

function slidersingle() {
	if(jQuery(".single-slider").length > 0) {
		var singleslider = new Swiper(".single-slider", {
			slidesPerView: 1,
			loop: true,
			autoplay: { delay: 8000, disableOnInteraction: false },
			speed: 700,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}
}

function rocersa_makecircle(ele, lt) {
	var element = document.getElementById(ele);
	if ( element ) {
		var b = new Circles({
			dom: element,
			color: "rgba(255,255,255,0.2)",
			left: lt,
			amplitude: 1,
		});
	}
}

export function addOrUpdateUrlParam( uri, paramKey, paramVal ) {
	var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");

	if ( re.test(uri) ) {
		uri = uri.replace(re, "$1" + paramKey + "=" + paramVal);

	} else {
		var separator = /\?/.test(uri) ? "&" : "?";
		uri = uri + separator + paramKey + "=" + paramVal;

	}

	return uri;
}


export function removelazy() {
	jQuery(".collpro-image").removeClass("nl-lazy");
}






export function ToggleMuteVideos(container) {

	var muteIcons = container.querySelectorAll('.muteicon');

	muteIcons.forEach( function(muteIcon) {
		var videoTag = muteIcon.dataset.video;

		muteIcon.addEventListener('click', function() {
			var videoEl = document.querySelector( videoTag );
			if (videoEl) {
				videoEl.muted = !videoEl.muted;
				muteIcon.classList.toggle('mute');
			}
		});
	});
}

function menu_init() {
	adddatatype();
}

/* Menu Functions */
function menuopen() {
	if (!document.querySelector('.nav-bg')) return;

	jQuery('.bottommenu-mobile').addClass('menu-active');
	jQuery('body').addClass('menuopen');

	let tl = gsap.timeline();
	tl
		.fromTo( '.nav-bg', { right: "100%", left: "0%", opacity:0.5, }, { duration: 0.7, right: 0, opacity: 1, left: 0, ease: 'Power4.easeIn', } );

	if (document.querySelector('.closemenu'))
		tl.fromTo( '.closemenu', { right: 75, opacity: 0 }, { duration: 0.2, right: 50, opacity: 1, ease: 'Power1.easeIn' }, 0.6 );
	if (document.querySelector('.navlogo'))
		tl.fromTo( '.navlogo', { x: -50, opacity: 0 }, { duration: 0.2, x: 0, opacity: 1, ease: 'Power1.easeOut' }, 0.6 );
	if (document.querySelectorAll('.nav-item-main ul li').length > 0)
		tl.fromTo( '.nav-item-main ul li', { x: -50, opacity: 0 }, { duration: 0.5, x: 0, opacity: 1, stagger: 0.1, ease: 'Power1.easeOut' }, 0.65 );
	if (document.querySelectorAll('.nav-item-main .lang-nav').length > 0)
		tl.fromTo( '.nav-item-main .lang-nav', { x: -50, opacity: 0 }, { duration: 0.5, x: 0, opacity: 1, stagger: 0.1, ease: 'Power1.easeOut' }, 0.65 );
}

function menuclose() {
	if (!document.querySelector('.nav-bg')) return;

	//jQuery('.bottommenu-mobile').removeClass('menu-active');
	jQuery('body').removeClass('menuopen');

	let tl = gsap.timeline();
	if (document.querySelector('.closemenu'))
		tl.to( '.closemenu', { duration: 0.1, right: 25, opacity: 0, ease: 'Power1.easeIn' }, 0.2 );
	if (document.querySelector('.navlogo'))
		tl.to( '.navlogo', { duration: 0.1, x: 50, opacity: 0, ease: 'Power1.easeOut' }, 0.15 );
	if (document.querySelectorAll('.nav-item-main ul li').length > 0)
		tl.to( '.nav-item-main ul li', { duration: 0.3, x: 50, opacity: 0, stagger: 0.1, ease: 'Power1.easeOut' }, 0 );
	if (document.querySelectorAll('.nav-item-main .lang-nav').length > 0)
		tl.to( '.nav-item-main .lang-nav', { duration: 0.3, x: 50, opacity: 0, stagger: 0.1, ease: 'Power1.easeOut' }, 0 );
	tl
		.fromTo( '.nav-bg', { right: "0", left: "0%", opacity: 1, }, { duration: 0.5, right: 0, opacity: 0.5, left: "100%", ease: 'Power4.easeIn', }, 0.3 )
		.add( function() { jQuery('.bottommenu-mobile').removeClass('menu-active'); } );
}

jQuery(window).scroll(function () {
	"use strict";
	if ( jQuery(this).scrollTop() > 350 ) {
		jQuery("body").addClass("scrolling");

	} else {
		jQuery("body").removeClass("scrolling");

	}

});

function closePopup(popup) {
	jQuery('.popup-content').data('fileurl', '' );
	jQuery(popup).removeClass('opened');
}

function openPopup(popup) {
	jQuery(popup).addClass('opened');
}




function descargas_tpl__cookie_status() {
    var descargas_tpl_cookie = getCookie("descargas_tpl_cookie");
    return ( descargas_tpl_cookie === "" ) ? false : true;
}

/* Cookies Functions */
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie(cname) {
    var user = getCookie(cname);
    if (user != "") {
        return true;
    } else {
        return false;
    }
}

function open_menu(id) {
	var mainele = jQuery('.nl-dropdown-menu');
	var ele = jQuery(id);
	var allele = jQuery('.dp-box');
	jQuery('.menucloaser').show();
	allele.hide();
	mainele.show();
	ele.show();
}

function close_menu() {
	var mainele = jQuery('.nl-dropdown-menu');
	var allele = jQuery('.dp-box');
	allele.hide();
	mainele.hide();
	jQuery('.menucloaser').hide();
}

function findtaxid() {
	var ele = jQuery('.taxpage-collector');
	if(ele != undefined) {
		var id = ele.data('collid');
		if ( jQuery('.collid-'+ id).hasClass("disabled") )
			return;
		jQuery('.collid-'+ id).toggleClass("clicked");
		FetchData();
	}
}

var sliders = {};
function sliderLam() {
	if(jQuery('.lam-slider').length > 0) {
		jQuery(".lam-slider").each(function(index) {
			var el = '#'+jQuery(this).attr('id');
			sliders[index] = new Swiper(el, {
				slidesPerView: 1,
				loop: false,
				speed: 700,
			});
		});
	}
}

function tabControl() {
	jQuery('.lam-tabcontent').addClass('tabactive');
	if(jQuery('.lam-tab-nav').length >0) {
		jQuery('.lam-tab-nav li').on('click', function() {
			var ele = jQuery(this).data('tab');
			jQuery('.lam-tab-nav li').removeClass('active');
			jQuery(this).addClass('active');
			jQuery('.lam-tabcontent').fadeOut();
			jQuery('.tab-'+ ele).fadeIn();
			if(sliders[ele]) { sliders[ele].update(); }
		});
	}
}

function lamDisplay() {
	if(jQuery('.v-heading').length > 0) {
		setTimeout(function() {
			jQuery('.v-heading').addClass('animate');
		}, 500);
	}

	if(jQuery('.lam-showcase').length <= 0) {
		return;
	}
	jQuery('.lam-tabopener').on('click', function() {
		if(jQuery(this).hasClass('active')) {
			return;
		} else {
			jQuery('.lam-tabopener').removeClass('active');
			jQuery('.lam-piece').slideUp();
			jQuery('.lam-piece').removeClass('active');
			jQuery('.lam-piece-image-wrap').removeClass('active-piece');
			jQuery('.person-svg').removeClass('active');
			jQuery(this).addClass('active');
			var child = jQuery(this).find('.lam-piece');
			child.slideDown();
			jQuery(this).find(".lam-piece:first-child").addClass('active');
			var col =jQuery(this).data('lamcollection');
			jQuery('.lam-piece-image-wrap').removeClass('active-coll');
			jQuery('.coll-'+col).addClass('active-coll');
			jQuery('.piece-0.coll-'+col).addClass('active-piece');

			setTimeout(function() {
				jQuery('.person-svg').addClass('active');
			}, 500);
		}

	});

	jQuery('.lam-piece').on('click', function() {
		if(jQuery(this).hasClass('active')) {
			return;
		} else {
			var col =jQuery(this).closest('.lam-tabopener').data('lamcollection');
			jQuery('.lam-piece').removeClass('active');
			jQuery('.lam-piece-image-wrap').removeClass('active-piece');
			jQuery('.person-svg').removeClass('active');
			jQuery(this).addClass('active');
			var pie =jQuery(this).data('lampiece');
			jQuery('.piece-'+pie+'.coll-'+col).addClass('active-piece');
			setTimeout(function() {
				jQuery('.person-svg').addClass('active');
			}, 700);
		}
	});
}
